// Edit site copy and contact details here.
export const CONTACT_EMAIL = "messengers@10thcelestial.com";

export const mailto = (subject) =>
  `mailto:${CONTACT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;

export const HERO = {
  overline: "Celestial insight · Purposeful strategy",
  lines: ["Where Intuition", "Meets Intention."],
  intro:
    "Where celestial insight meets purposeful strategy. We offer personalized consultations combining thoughtful interpretation, professional expertise, and practical guidance.",
};

export const MARQUEE = [
  "Astrological Consultation",
  "Business & Operational Strategy",
  "Integrated Consultation",
  "As Above, So Below",
  "Personalized Guidance",
];

export const SERVICES = [
  {
    id: "oracles-table",
    numeral: "I",
    glyph: "sun",
    title: "The Oracle’s Table",
    subtitle: "Astrological Consultation",
    body:
      "Personalized astrological readings exploring natal charts, personal patterns, life transitions, and individual aspirations through symbolic interpretation and thoughtful reflection.",
    tags: ["Natal charts", "Personal patterns", "Life transitions"],
  },
  {
    id: "alchemists-blueprint",
    numeral: "II",
    glyph: "moon",
    title: "The Alchemist’s Blueprint",
    subtitle: "Business & Operational Consultation",
    body:
      "Professional advisory services focused on business strategy, brand positioning, marketing, risk management, process optimization, and operational development.",
    tags: ["Strategy", "Brand positioning", "Operations"],
  },
  {
    id: "as-above-so-below",
    numeral: "III",
    glyph: "union",
    title: "As Above, So Below",
    subtitle: "Integrated Astrology & Business Consultation",
    body:
      "A combined service integrating astrological reflection with practical business consulting, offering symbolic perspectives alongside structured business strategies and actionable recommendations.",
    note:
      "Astrological interpretation is offered as a reflective, symbolic framework — distinct from the evidence-based business guidance it accompanies.",
    tags: ["Symbolic reflection", "Structured strategy", "Actionable recommendations"],
  },
];

export const CONTACT = {
  heading: "Begin a Conversation",
  line: "Every meaningful journey begins with an inquiry.",
  invites: ["Consultation inquiries", "Referrals", "Professional collaborations"],
  note: "Details, arrangements and scheduling are shared personally by email.",
};

export const ABOUT = [
  {
    id: "architect",
    glyph: "moon",
    name: "The Architect",
    roles: "Lean Six Sigma Black Belt | Business Operations & Risk Management Strategist",
    body:
      "Specializing in operational development, risk management, process optimization, and strategic implementation. The Architect brings structured methodology and practical business expertise to help organizations build efficient, sustainable, and scalable operations.",
  },
  {
    id: "oracle",
    glyph: "sun",
    name: "The Oracle",
    roles: "Astrological Practitioner | Philosophical & Symbolic Interpretation | Brand & Marketing Strategist",
    body:
      "Astrological practitioner since 2019, specializing in astrological interpretation, natal chart analysis, and philosophical exploration. Integrates astrological symbolism with analytical reasoning and a background in Philosophy to provide reflective, personalized readings, complemented by professional expertise in branding, marketing, and strategic communication.",
  },
];

export const PRIVACY = {
  effective: "January 22, 2026",
  intro: "At 10THCELESTIAL, we value the privacy, trust, and confidentiality of every individual and organization we serve.",
  sections: [
    {
      title: "Information We Collect",
      body: "When you contact us or request a consultation, we may collect your name, email address, contact details, and information voluntarily provided regarding your inquiry. Depending on the consultation, this may include birth details, personal circumstances, or business information.",
    },
    {
      title: "How We Use Your Information",
      body: "Information is collected and used solely for responding to inquiries, assessing consultation suitability, arranging and providing services, maintaining necessary records, and fulfilling applicable legal obligations.",
    },
    {
      title: "Confidentiality",
      body: "We treat consultation discussions, personal disclosures, and proprietary business information as confidential. Information will not be disclosed to unauthorized parties, except with appropriate authorization, to necessary service providers under suitable safeguards, or when required or permitted by law.",
    },
    {
      title: "Data Protection and Retention",
      body: "We implement reasonable measures to protect personal information against unauthorized access, disclosure, loss, or misuse. Information is retained only as long as reasonably necessary for the stated purposes or applicable legal requirements.",
    },
    {
      title: "Your Rights",
      body: "In accordance with the Philippine Data Privacy Act of 2012 (Republic Act No. 10173), you may exercise applicable rights concerning your personal information, including requesting access, correction, or deletion, objecting to certain processing, and filing a complaint with the National Privacy Commission.",
    },
  ],
  closing: "By contacting us, you acknowledge that you have been provided this Privacy & Confidentiality Notice.",
};
